import "./WConsoleModal.moduleRenamed.css";

export const logList = "WConsoleModal-module__logList___k1opI";
export const collapsePanel = "WConsoleModal-module__collapsePanel___-o8VG";
export const modalTitlePs = "WConsoleModal-module__modalTitlePs___PV9Mx";
export const collapseHeader = "WConsoleModal-module__collapseHeader___ScsDA";
export const collapseDetail = "WConsoleModal-module__collapseDetail___a0T2p";
export const request = "WConsoleModal-module__request___R-Eue";
export const expiredAlert = "WConsoleModal-module__expiredAlert___t2RUE";
export const wconsoleSpan = "WConsoleModal-module__wconsoleSpan___XDRgI";
export const logTitle = "WConsoleModal-module__logTitle___spyxj";
export const copy = "WConsoleModal-module__copy___ba3Pa";
export const searchInput = "WConsoleModal-module__searchInput___p4P7W";
export const importantClass = "WConsoleModal-module__importantClass___ATU8w";

export default {
  logList: "WConsoleModal-module__logList___k1opI",
  collapsePanel: "WConsoleModal-module__collapsePanel___-o8VG",
  modalTitlePs: "WConsoleModal-module__modalTitlePs___PV9Mx",
  collapseHeader: "WConsoleModal-module__collapseHeader___ScsDA",
  collapseDetail: "WConsoleModal-module__collapseDetail___a0T2p",
  request: "WConsoleModal-module__request___R-Eue",
  expiredAlert: "WConsoleModal-module__expiredAlert___t2RUE",
  wconsoleSpan: "WConsoleModal-module__wconsoleSpan___XDRgI",
  logTitle: "WConsoleModal-module__logTitle___spyxj",
  copy: "WConsoleModal-module__copy___ba3Pa",
  searchInput: "WConsoleModal-module__searchInput___p4P7W",
  importantClass: "WConsoleModal-module__importantClass___ATU8w",
};